"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalJepMode = exports.isValidJEPMode = exports.JEP_MODE = void 0;
const dotenv_1 = require("dotenv");
var JEP_MODE;
(function (JEP_MODE) {
    JEP_MODE["dev"] = "dev";
    JEP_MODE["prod"] = "prod";
    JEP_MODE["test"] = "test";
})(JEP_MODE || (exports.JEP_MODE = JEP_MODE = {}));
const isValidJEPMode = (jepMode) => {
    return Object.values(JEP_MODE).includes(jepMode);
};
exports.isValidJEPMode = isValidJEPMode;
const getGlobalJepMode = () => {
    var _a;
    (0, dotenv_1.config)();
    const jepMode = (_a = process.env.JEP_MODE) !== null && _a !== void 0 ? _a : process.env.NEXT_PUBLIC_JEP_MODE;
    return (0, exports.isValidJEPMode)(jepMode) ? jepMode : JEP_MODE.dev;
};
exports.getGlobalJepMode = getGlobalJepMode;
//# sourceMappingURL=jepMode.js.map